exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.goods-popover-img{\n    margin-top: 5px;\n    margin-bottom: 5px;\n    background:#000;\n    border:1px solid #fff;\n    border-width:5px 5px 5px 5px;\n    box-shadow:1px 1px 5px #333;\n    -webkit-box-shadow:1px 1px 5px #333;\n    -moz-box-shadow:1px 1px 5px #333;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-03f4bc4a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/member/inform.vue
// module id = 1179
// module chunks = 0